// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2koVu","content":"layout-module--content--2nJs5"};